import * as newComment from "./newcomment";
import * as pageComments from "./pagecomments";

export function init(options) {
    const o = {
        page: {},
        comments: [],
        ...options
    };

    let commentsModel = pageComments.init(o.comments);
    newComment.init(o.page, commentsModel);
}


// WEBPACK FOOTER //
// ./modules/blog/pagecomments/index.js